import React, { FC } from "react";
import DataHeaderType from "../../../../old/Types/DataHeaderType";
import * as ST from "./styled";
import { Typography } from "@mui/material";
import { useState } from "react";
import { ReactComponent as IconArrow } from "../../../Assets/arrow-menu.svg";
import SubMenuLvl2 from "./DesctopSubMenu/SubMenuSecondLevel";
import { URLHOST } from "../../../Const/envConst";

type ListNavigationProps = {
	data: DataHeaderType[];
};

const ListNavigation: FC<ListNavigationProps> = ({ data }) => {
	const [openSubmenuId, setOpenSubmenuId] = useState<number | null>(null);
	const [hideTimeoutId, setHideTimeoutId] = useState<NodeJS.Timeout | null>(
		null
	);

	const handleSubMenuOpen = (
		event: React.MouseEvent<HTMLElement>,
		id: number
	) => {
		setOpenSubmenuId(id);
	};

	const handleDelayedSubMenuClose = () => {
		const timeoutId = setTimeout(() => {
			setOpenSubmenuId(null);
		}, 200);

		setHideTimeoutId(timeoutId);
	};

	const handleCancelCloseSubMenu = () => {
		if (hideTimeoutId) {
			clearTimeout(hideTimeoutId);
			setHideTimeoutId(null);
		}
	};

	return (
		<ST.ListNavigation>
			{data.map((itemNavigation) => (
				<ST.ItemNavigation key={itemNavigation.id}>
					{/*lvl 1*/}
					<ST.Link
						href={`${itemNavigation.path}`}
						onMouseEnter={(event) => {
							handleCancelCloseSubMenu();
							itemNavigation.children &&
								handleSubMenuOpen(event, itemNavigation.id);
						}}
						onMouseLeave={(e) => {
							handleDelayedSubMenuClose();
						}}
					>
						{/* subtitle2 - все, subtitle1 - выбранное */}
						<ST.LogoWrapper>
							<ST.ArrowWrapper isHovered={true}>
								<Typography variant="h6">{itemNavigation.name}</Typography>
								{itemNavigation.children?.length ? <IconArrow /> : ""}
							</ST.ArrowWrapper>
						</ST.LogoWrapper>
					</ST.Link>

					{/*lvl 2*/}
					{itemNavigation.children && (
						<SubMenuLvl2
							items={itemNavigation.children}
							isVisible={openSubmenuId === itemNavigation.id}
							subMenuCloseHandler={handleDelayedSubMenuClose}
							cancelHideSubMenuHandler={handleCancelCloseSubMenu}
						/>
					)}
				</ST.ItemNavigation>
			))}
		</ST.ListNavigation>
	);
};

export default ListNavigation;
